import CustomAction, {
  BaseActionInputData,
  COMMON_ACTION_TAGS,
} from '../BaseCustomAction';

// Question generation specific input data
export interface QuestionGenerationInputData extends BaseActionInputData {
  taskId: string;
  subject?: string;
  questionType?: string;
  isCustom?: boolean;
  errorType?: string;
  batchSize?: number;
}

// Question generation specific tags
export const QUESTION_ACTION_TAGS = {
  ...COMMON_ACTION_TAGS,
  SUBJECT: 'subject',
  TASK_ID: 'task_id',
  ERROR_TYPE: 'error_type',
  STATUS: 'status',
  CUSTOM_QUESTION: 'is_custom',
  QUESTION_TYPE: 'question_type',
  QUESTION_ID: 'question_id',
  REQUESTED_COUNT: 'requested_count',
  SUBMITTED_COUNT: 'submitted_count',
  DELETED_COUNT: 'deleted_count',
  GENERATED_COUNT: 'generated_count',
  FAILED_COUNT: 'failed_count',
  GENERATION_TIME: 'generation_time',
} as const;

// Base class for all question generation actions
export abstract class BaseQuestionGeneration extends CustomAction<QuestionGenerationInputData> {
  // eslint-disable-next-line class-methods-use-this
  prepareTags(input: QuestionGenerationInputData): Record<string, any> {
    const tags: Record<string, any> = {
      [QUESTION_ACTION_TAGS.TASK_ID]: input.taskId,
    };

    if (input.subject) {
      tags[QUESTION_ACTION_TAGS.SUBJECT] = input.subject;
    }

    if (input.questionType) {
      tags[QUESTION_ACTION_TAGS.QUESTION_TYPE] = input.questionType;
    }

    if (input.isCustom !== undefined) {
      tags[QUESTION_ACTION_TAGS.CUSTOM_QUESTION] = input.isCustom;
    }

    if (input.errorType) {
      tags[QUESTION_ACTION_TAGS.ERROR_TYPE] = input.errorType;
    }

    // Include any additional custom tags
    if (input.tags) {
      Object.entries(input.tags).forEach(([key, value]) => {
        tags[key] = value;
      });
    }

    return tags;
  }
}
